<div class="no-record-wrapper flex flex-col justify-center items-center p-4">
  <mat-spinner diameter="32" class="block mb-2"></mat-spinner>
  <p class="text-lightGray text-base">Data is loading...</p>
</div>
